<template>
  <div v-if="stock">
    <table class="table borderless">
      <tbody>
        <tr>
          <td style="border-top: none">Название</td>
          <td style="border-top: none">{{ stock.title }}</td>
        </tr>
        <tr>
          <td>Поступление</td>
          <td>{{ stock.receipt }}</td>
        </tr>
        <tr>
          <td>Количество</td>
          <td>{{ stock.quantity }}</td>
        </tr>
        <tr>
          <td>Поставщик</td>
          <td>{{ getSupplier(stock) }}</td>
        </tr>
        <tr>
          <td>Дата производства</td>
          <td>{{ stock.date | formatDate }}</td>
        </tr>
        <tr>
          <td>Объект</td>
          <td>{{ stock.facility.name }}</td>
        </tr>
        <template v-if="showPriceAndSum">
          <tr>
            <td>Стоимость 1 шт</td>
            <td>{{ stock.price }}</td>
          </tr>
          <tr>
            <td>Сумма, руб</td>
            <td>{{ stock.stockSum }}</td>
          </tr>
        </template>
      </tbody>
    </table>
    <div>
      <h4>История изменений</h4>
      <span v-if="!stock.logs || !stock.logs.length">Изменения отсутствуют</span>
      <template v-else>
        <div v-for="log in listLogs" :key="log.id">
          <div><b>Обновил: </b>{{ log.modifierName }}</div>
          <div><b>Дата изменения:</b> {{ log.updated_at | formatDateTime }}</div>
          <div v-if="log.type">
            <b>Тип изменения:</b> {{ log.type.title }}
            <div v-if="log.changes[0]['car_id']" class="d-inline">
              <span> машины </span>
              <router-link :to="'/maintenance/car/' + log.changes[0]['car_id']">
                #{{ log.changes[0]['car_id'] }}
              </router-link>
            </div>
          </div>
          <div><b>Изменения:</b></div>
          <div class="ml-3">
            <div
              v-for="change in log.changes"
              :key="log.id + change.attribute_name"
              class="m-1"
            >
              <span>{{ change.attribute_title }}: </span>
              <div v-if="change.attribute_name == 'facility_id'" class="d-inline-flex">
                <b>{{ getFacilityName(change.oldValue) }}</b>
                <span class="change-separator">
                  <font-awesome-icon icon="long-arrow-alt-right" />
                </span>
                <b>{{ getFacilityName(change.newValue) }}</b>
              </div>
              <div v-else-if="change.attribute_name == 'supplier_id'" class="d-inline-flex">
                <b>{{ getSupplierName(change.oldValue) }}</b>
                <span class="change-separator">
                  <font-awesome-icon icon="long-arrow-alt-right" />
                </span>
                <b>{{ getSupplierName(change.newValue) }}</b>
              </div>
              <div v-else-if="change.attribute_name == 'date'" class="d-inline-flex">
                <b>{{ change.oldValue | formatDate }}</b>
                <span class="change-separator">
                  <font-awesome-icon icon="long-arrow-alt-right" />
                </span>
                <b>{{ change.newValue | formatDate }}</b>
              </div>
              <div v-else class="d-inline-flex">
                <b>{{ change.oldValue }}</b>
                <span class="change-separator">
                  <font-awesome-icon icon="long-arrow-alt-right" />
                </span>
                <b>{{ change.newValue }}</b>
              </div>
            </div>
          </div>
          <hr>
        </div>
        <div>
          <span
            :style="buttonStyle"
            style="margin: 0 20px"
            @click="currentPage++"
          >
            Показать {{ logsOnPage }} следующих записей
          </span>
          <span
            :style="buttonStyle"
            style="margin: 0 20px"
            @click="showAll = true"
          >
            Показать все
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import {mapActions, mapState} from 'vuex'

export default {
  name: 'StockShow',
  props: {
    stock: {
      type: Object,
      default: () => null
    },
    showPriceAndSum: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      logsOnPage: 5,
      currentPage: 1,
      showAll: false
    }
  },
  computed: {
    getSupplier () {
      return (stock) => {
        return stock.supplier?.name
      }
    },
    getFacilityName () {
      return (id) => {
        return this.facilities.find(f => f.id == id)?.name
      }
    },
    getSupplierName () {
      return (id) => {
        return this.suppliers.find(s => s.id == id)?.name
      }
    },
    listLogs() {
      if (this.showAll) {
        return this.stock?.logs
      }
      const end = this.currentPage * this.logsOnPage
      return this.stock?.logs?.slice(0, end)
    },
    hasMoreLogs() {
      return !this.showAll && (this.currentPage * this.logsOnPage < this.stock?.logs.length)
    },
    buttonStyle () {
      return {
        'color': this.hasMoreLogs ? '#007bff' : '#cccccc',
        'cursor': this.hasMoreLogs ? 'pointer' : 'default'
      }
    },
    ...mapState('facility/facility', {
      facilities: state => state.items
    }),
    ...mapState('supplier/supplier', {
      suppliers: state => state.items
    }),
  },
  mounted () {
    this.loadFacility()
    this.loadSupplier()
  },
  methods: {
    ...mapActions('facility/facility', {
      loadFacility: 'loadItems',
    }),
    ...mapActions('supplier/supplier', {
      loadSupplier: 'loadItems',
    }),
  }
}
</script>

<style scoped>
  .change-separator {
    align-self: center;
    margin: 0 5px;
  }
</style>
